/**
 * Created by Qingger Corp.
 * User: Thinkpad
 * Date: 2019/6/10
 * Time: 9:37
 * Desc: 网点管理-网点信息-虚拟店长
 */

import { Component, Vue } from 'vue-property-decorator';
import { quillEditor } from 'vue-quill-editor'; // Vue富文本编辑器
import { IPSService } from '@/services/ipsServices';
import editorOptionConfig from '@/library/utils/editerOptionConfig'; // 富文本编辑器全局配置

// 子组件

@Component({
  components: {
    quillEditor,
  },
})
export default class SiteVirtualManager extends Vue {
  /* 属性 */

  /**
   * 是否启用虚拟店长
   * @type {boolean}
   */
  public isVirtualManagerOpen = false;

  /* 数据 */

  /**
   * 分销策略
   * @type {ItemObject}
   */
  public distributeStrategyList: Array<GuiderConfig> = [];

  /**
   * 富文本配置
   * @type {ItemObject}
   */
  public editorOptionConfig: ItemObject = editorOptionConfig('readOnly');

  /**
   * 虚拟店长表单
   * @type {ItemObject}
   */
  public siteVirtualManagerForm: ItemObject = {
    commissionProportion: '0', // 佣金比例 0.9是90%
    commissionTime: 0, // 佣金结算周期（天
    discountLimitProportion: '0', // 最终结算价低于商品原价XX%不计算佣金
    deposit: 0, // 押金
    groupId: 0, // 集团ID
    outContent: '', // 提现须知
    outMaxNumber: 10, // 每天可提现次数
    outMinAmount: 0, // 起提额度(分)
    outTotalAmount: 0, // 每天累计可提现金额
    policyId: '', // 配置ID
    policyName: '', // 策略组名称
    shareCacheTime: '24', // 收分享收益时效
    cardWatermark: '', // 身份证水印
    shopownerAgreement: '', // 虚拟店长用户协议
    shopownerContent: '', // 虚拟店长介绍页
    secondMaxPerson: 0, // 下线人数限制
    secondCommissionProportion: 0, // 二级分销佣金比例
    secondValidityPeriodDay: 0, // 下线有效期 天
    secondVisitPage: '', // 好友邀请
    isShowSecond: false, // 前端是否显示二级分销
    secondSharePicture: '', // 分享图
    isHasOrder: 0, // 有过购买才允许申请 0关闭，1开启
    orderMinPrice: 0, // 条件下订单完成的总额
    orderDaysAgo: 0, // n天前完成的订单
    secondShopownerAgreement: '', // 二级用户协议
  };

  /* 方法 */

  /**
   * 切换分销策略
   * @return null
   */
  public onSwitchPolicy(): void {
    this.getStrategyInfo(); // 获取策略信息
  }

  /**
   * 获取网点信息
   * @return null
   */
  public getSiteInfo(): void {
    const queryParams = {
      siteId: Number.parseInt(this.$route.params.siteId),
      moduleType: 4,
    };
    IPSService.siteInfo({ queryParams })
      .then((res) => {
        this.isVirtualManagerOpen = res.vGuiderConfig && res.vGuiderConfig.constructor !== Array;
        if (res.vGuiderConfig) {
          res.vGuiderConfig.commissionProportion = res.vGuiderConfig.commissionProportion ? (res.vGuiderConfig.commissionProportion * 100).toFixed(2) : 0;
          res.vGuiderConfig.discountLimitProportion = res.vGuiderConfig.discountLimitProportion ? (res.vGuiderConfig.discountLimitProportion * 100).toFixed(2) : 0;
          res.vGuiderConfig.deposit = res.vGuiderConfig.deposit ? (res.vGuiderConfig.deposit / 100).toFixed(2) : 0;
          res.vGuiderConfig.outMinAmount = res.vGuiderConfig.outMinAmount ? (res.vGuiderConfig.outMinAmount / 100).toFixed(2) : 0;
          res.vGuiderConfig.outTotalAmount = res.vGuiderConfig.outTotalAmount ? (res.vGuiderConfig.outTotalAmount / 100).toFixed(2) : 0;
          res.vGuiderConfig.policyId = res.vGuiderConfig.policyId ? `${res.vGuiderConfig.policyId}` : '';
          this.siteVirtualManagerForm = res.vGuiderConfig;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /**
   * 获取策略信息
   * @return null
   */
  public getStrategyInfo(): void {
    const queryParams = {
      policyId: Number.parseInt(this.siteVirtualManagerForm.policyId),
    };
    this.clearData();
    IPSService.guiderConfigInfo({ queryParams }).then((res) => {
      res.commissionProportion = res.commissionProportion ? res.commissionProportion * 100 : 0;
      res.secondCommissionProportion = res.secondCommissionProportion ? res.secondCommissionProportion * 100 : 0;
      res.discountLimitProportion = res.discountLimitProportion ? res.discountLimitProportion * 100 : 0;
      res.deposit = res.deposit ? (res.deposit / 100).toFixed(2) : 0;
      res.outMinAmount = res.outMinAmount ? (res.outMinAmount / 100).toFixed(2) : 0;
      res.outTotalAmount = res.outTotalAmount ? (res.outTotalAmount / 100).toFixed(2) : 0;
      res.policyId = `${res.policyId}`;
      this.siteVirtualManagerForm = res;
    });
  }

  /**
   * 提交数据
   * @return null
   */
  public ontryOnListData(): void {
    const postParams = {
      siteId: Number.parseInt(this.$route.params.siteId),
      policyId: 0,
      moduleType: 4,
    };
    const siteVirtualManagerForm = JSON.parse(JSON.stringify(this.siteVirtualManagerForm));
    siteVirtualManagerForm.commissionProportion = `${siteVirtualManagerForm.commissionProportion / 100}`;
    siteVirtualManagerForm.discountLimitProportion = `${siteVirtualManagerForm.discountLimitProportion / 100}`;

    if (this.isVirtualManagerOpen && this.siteVirtualManagerForm.policyId) {
      postParams.policyId = Number.parseInt(this.siteVirtualManagerForm.policyId);
    } else if (this.isVirtualManagerOpen && !this.siteVirtualManagerForm.policyId) {
      this.$message.error('请选择分销策略');
      return;
    } else {
      postParams.policyId = 0;
    }
    IPSService.saveSiteEdit({ postParams }).then((res) => {
      if (res) { this.$message.success('保存成功'); }
    });
  }

  /**
   * 获取虚拟店长策略列表信息
   * @return null
   */
  public getGuiderConfigList(): void {
    IPSService.guiderConfigList({}).then((res: any) => {
      res.list.forEach((item) => {
        item.policyId = `${item.policyId}`;
      });
      this.distributeStrategyList = res.list;
    });
  }

  /**
   * 清除数据
   * @return null
   */
  public clearData(): void {
    this.siteVirtualManagerForm = {
      commissionProportion: '0', // 佣金比例 0.9是90%
      commissionTime: 0, // 佣金结算周期（天
      deposit: 0, // 押金
      groupId: 0, // 集团ID
      outContent: '', // 提现须知
      outMaxNumber: 10, // 每天可提现次数
      outMinAmount: 0, // 起提额度(分)
      outTotalAmount: 0, // 每天累计可提现金额
      policyId: '', // 配置ID
      policyName: '', // 策略组名称
      shareCacheTime: '24', // 收分享收益时效
      cardWatermark: '', // 身份证水印
      shopownerAgreement: '', // 虚拟店长用户协议
      shopownerContent: '', // 虚拟店长介绍页
      isHasOrder: 0, // 有过购买才允许申请 0关闭，1开启
      orderMinPrice: 0, // 条件下订单完成的总额
      orderDaysAgo: 0, // n天前完成的订单
      isShowSecond: false, // 是否为虚拟店长
      secondMaxPerson: 0, // 下线人数限制
      secondCommissionProportion: 0, // 二级分销佣金比例
      secondValidityPeriodDay: 0, // 下线有效期
      secondVisitPage: '', // 好友邀请页
      secondSharePicture: '', // 分享图
      secondShopownerAgreement: '', // 二级用户协议
    };
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getGuiderConfigList(); // 获取虚拟店长策略列表信息
    this.getSiteInfo(); // 获取网点信息
  }
}
